import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { GOODS_RECEIPT_ITEM } from '../types/goods-receipt-item.js';
/**
 * Descriptor for GoodsReceiptItem.
 * Path: org/{orgId}/goods-receipt/{goodsReceiptId}/item
 */
export const goodsReceiptItemDescriptor = {
    name: GOODS_RECEIPT_ITEM,
    label: 'Item do recebimento',
    domain: 'purchasing',
    collectionPath: 'org/{orgId}/goods-receipt/{goodsReceiptId}/item',
    pathPatternKeys: {
        orgId: 'string',
        goodsReceiptId: 'string',
    },
    version: 1,
    description: 'Goods receipt line — ProductRef + lot + location + qty',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'goodsReceiptId', label: 'Recebimento', type: 'string', required: true },
        { name: 'purchaseOrderItemId', label: 'Item da OC', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        { name: 'quantity', example: 300, label: 'Quantidade', type: 'number', required: true },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'purchaseOrderItemId',
            targetEntity: 'PurchaseOrderItem',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=goods-receipt-item.descriptor.js.map